import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0970E6",
      "fill-rule": "evenodd",
      d: "M11.527 4.466a5.829 5.829 0 0 0-6.341 9.782.75.75 0 1 1-.816 1.26 7.329 7.329 0 0 1 7.973-12.3.75.75 0 0 1-.816 1.258m3.614 5.465a3.63 3.63 0 0 1 1.778.39c.354.18.789.04.97-.31a.71.71 0 0 0-.313-.962 5.09 5.09 0 0 0-4.929.183 5.02 5.02 0 0 0-2.121 2.578h-1.2a.72.72 0 0 0-.722.714c0 .395.323.715.721.715h.91a5 5 0 0 0 0 .523h-.91a.72.72 0 0 0-.72.714c0 .395.322.715.72.715h1.201q.14.384.341.744a5 5 0 0 0 1.764 1.823 5.08 5.08 0 0 0 4.928.201.71.71 0 0 0 .317-.96.724.724 0 0 0-.97-.314 3.64 3.64 0 0 1-3.52-.144 3.6 3.6 0 0 1-1.285-1.35h2.372c.398 0 .721-.32.721-.715a.72.72 0 0 0-.721-.714H11.68a3.6 3.6 0 0 1 0-.524h2.793c.398 0 .721-.32.721-.714a.72.72 0 0 0-.721-.714H12.1l.034-.061c.302-.533.738-.98 1.264-1.298a3.6 3.6 0 0 1 1.743-.52M23 13.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-1.5 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }